// removed by extract-text-webpack-plugin
module.exports = {"compare-fund-widget-trigger":"compare-fund-widget-trigger__3uyIw","compare-widget-btn":"compare-widget-btn__1gg3N","close-widget":"close-widget__38xnG","compare-fund-widget":"compare-fund-widget__2U3gU","badge":"badge__21Nuc","fund-container":"fund-container__1saLk","fund":"fund__1B8Cq"};


//////////////////
// WEBPACK FOOTER
// ./styles/common/compareFundWidget.scss
// module id = 289
// module chunks = 68